<template>
  <div class="modal active">
    <div class="modal-overlay"></div>

    <div class="modal-container modal-form modal-form--xs">
      <header class="modal-header modal-form__header">
        <a
          aria-label="close"
          class="btn btn-clear float-right modal-form__close"
          @click="close()"
        >
        </a>

        <h1 class="modal-form__title">Envio de recibo</h1>
      </header>

      <article class="modal-body modal-form__body">
        <div class="modal-form__wrapper">
          <p class="modal-form__text modal-form__text--no-margin modal-form__text--mb">
            Por favor, confirme abaixo o endereço que receberá o recibo por e-mail:
          </p>

          <div
            v-for="field in formData"
            :key="`specialPatientFormField_${field.name}`"
            :class="[field.hide && 'modal-form__item--hidden', field.class]"
            class="modal-form__item"
          >
            <div
              v-if="field.hasIcon"
              class="modal-form__col modal-form__col--icon"
            >
              <dr-icon
                v-if="field.icon"
                :name="field.icon"
                fill="gray"
                class="modal-form__icon"
              />
            </div>

            <div class="modal-form__col">
              <div class="modal-form__field">
                <dr-field
                  :key="`specialPatient_${field.name}`"
                  :ref="field.name"
                  :id="field.name"
                  :validators.sync="$v.formData[field.name]"
                  :form.sync="formData"
                  :field="field"
                  :class="[
                    field.value && 'has-value',
                    (field.name === 'date' && $v.formData[field.name].$invalid) && 'has-error'
                  ]"
                  class="modal-form__input"
                  prefix="specialPatientForm_"
                />
              </div>
            </div>
          </div>
        </div>
      </article>

      <footer class="modal-form__footer">
        <button
          class="modal-form__btn-primary  "
          @click.prevent="sendMail()"
        >
          Enviar e-mail
        </button>

        <button
          class="modal-form__remove"
          @click.prevent="close()"
        >
          Cancelar
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import DrField from '@/components/form/field'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'DrReceiptSendEmail',

  props: {
    id: {
      type: Number,
      required: true
    },

    email: {
      type: String,
      required: false
    }
  },

  components: {
    DrField
  },

  validations: {
    formData: {
      email: {
        value: {
          required,
          email
        }
      }
    }
  },

  data () {
    return {
      formData: {
        email: {
          size: 12,
          type: 'text',
          name: 'email',
          placeholder: 'Endereço de e-mail',
          value: null,
          hasIcon: true,
          icon: 'email'
        }
      }
    }
  },

  created () {
    this.formData.email.value = this.email
  },

  methods: {
    sendMail () {
      const email = this.formData.email.value
      const url = `/agenda/${this.id}/payment_receipt/send_email`
      const data = { 'payment_receipt_mail': { email } }

      this.fn_SHOW_PROGRESS()
      this.$http
        .post(url, data, this.$store.getters.getAuthHeader)
        .then(() => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Recibo enviado com sucesso.',
            size: 'md',
            active: true
          })
        })
        .catch(err => this.fn_HANDLE_ERROR(err))
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.close()
        })
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>
